"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListModal = exports.getLatestDocumentVersion = exports.getDocumentBrand = exports.getDocumentVersionNumberOnly = exports.getDocumentVersionByDate = exports.omegaBreakDownIntroducedVersion = exports.DocVersionEnum = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var uuid_1 = require("uuid");
var rxjs_1 = require("rxjs");
var DocProductEnum;
(function (DocProductEnum) {
    DocProductEnum["ANNUAL_CAR"] = "Annual_Car";
    DocProductEnum["CAR"] = "Car";
    DocProductEnum["RENTERS"] = "Renters";
})(DocProductEnum || (DocProductEnum = {}));
var DocTypeEnum;
(function (DocTypeEnum) {
    DocTypeEnum["BDI"] = "BDI";
    DocTypeEnum["DOI"] = "DOI";
    DocTypeEnum["IPID"] = "IPID";
    DocTypeEnum["IPID_ALLIANZ_ESSENTIALS"] = "IPID_ALLIANZ_ESSENTIALS";
    DocTypeEnum["IPID_ALLIANZ_SILVER"] = "IPID_ALLIANZ_SILVER";
    DocTypeEnum["MLE"] = "MLE";
})(DocTypeEnum || (DocTypeEnum = {}));
var DocVersionEnum;
(function (DocVersionEnum) {
    DocVersionEnum["V1"] = "v1";
    DocVersionEnum["V2"] = "v2";
    DocVersionEnum["V3"] = "v3";
    DocVersionEnum["V4"] = "v4";
    DocVersionEnum["V5"] = "v5";
    DocVersionEnum["V6"] = "v6";
    DocVersionEnum["V7"] = "v7";
    DocVersionEnum["V8"] = "v8";
})(DocVersionEnum || (exports.DocVersionEnum = DocVersionEnum = {}));
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// To add new documents:
//      1. You need to add them to frontend/falcon-styles/public/resources/*under the appropriate brand and version*
//      2. Add the start date of the new documents to the map below.
// Keep in mind the document path pattern: {brand}{product}/{version}/{brand}{product}{document type}{version}
var AnnualCarVersionDate = [
    { docVersion: DocVersionEnum.V8, versionDate: new Date("2025-05-22") },
    { docVersion: DocVersionEnum.V7, versionDate: new Date("2025-01-16") },
    { docVersion: DocVersionEnum.V6, versionDate: new Date("2024-07-11") },
    { docVersion: DocVersionEnum.V5, versionDate: new Date("2024-05-16") },
    { docVersion: DocVersionEnum.V4, versionDate: new Date("2023-08-24") },
    { docVersion: DocVersionEnum.V3, versionDate: new Date("2022-08-05") },
    { docVersion: DocVersionEnum.V2, versionDate: new Date("2021-11-30") },
];
var CarVersionDate = [
    { docVersion: DocVersionEnum.V3, versionDate: new Date("24-08-2023") },
    { docVersion: DocVersionEnum.V2, versionDate: new Date("11-03-2021") },
];
var RentersVersionDate = [
    { docVersion: DocVersionEnum.V2, versionDate: new Date("11-03-2021") }
];
var DocNameMap = [
    { docType: DocTypeEnum.BDI, docFullName: "Allianz Annual Breakdown Document of Insurance " },
    { docType: DocTypeEnum.DOI, docFullName: "Allianz Car Document of Insurance (DOI)" },
    { docType: DocTypeEnum.IPID, docFullName: "Allianz Insurance Product Information Document (IPID)" },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_ESSENTIALS,
        docFullName: "Allianz Essentials Insurance Product Information Document (IPID)"
    },
    {
        docType: DocTypeEnum.IPID_ALLIANZ_SILVER,
        docFullName: "Allianz Silver Insurance Product Information Document (IPID)"
    },
    { docType: DocTypeEnum.MLE, docFullName: "Allianz Motor Legal Expenses (MLE)" }
];
var BrandEnum;
(function (BrandEnum) {
    BrandEnum["Allianz"] = "Allianz";
    BrandEnum["Flow"] = "Flow";
})(BrandEnum || (BrandEnum = {}));
// Document version when Britannia Rescue BDI document was introduced
exports.omegaBreakDownIntroducedVersion = 7;
function getDocumentVersionByDate(startDate) {
    var documentVersion = AnnualCarVersionDate
        .filter(function (doc) { return doc.versionDate <= startDate; }) // Filter out future dates
        .reduce(function (latest, current) {
        return current.versionDate > latest.versionDate ? current : latest;
    }, { docVersion: DocVersionEnum.V1, versionDate: new Date(0) }).docVersion;
    return documentVersion;
}
exports.getDocumentVersionByDate = getDocumentVersionByDate;
function getDocumentVersionNumberOnly(version) {
    // removes leading "v" or "V"
    var num = Number(version === null || version === void 0 ? void 0 : version.replace(/^v/i, ""));
    // in case of an error, use latest document version
    return isNaN(num) ? getDocumentVersionNumberOnly(getLatestDocumentVersion()) : num;
}
exports.getDocumentVersionNumberOnly = getDocumentVersionNumberOnly;
function getDocumentBrand(documentVersion) {
    switch (documentVersion) {
        case DocVersionEnum.V1:
        case DocVersionEnum.V2:
        case DocVersionEnum.V3:
            return BrandEnum.Flow;
        default:
            return BrandEnum.Allianz;
    }
}
exports.getDocumentBrand = getDocumentBrand;
function getLatestDocumentVersion() {
    return AnnualCarVersionDate[0].docVersion;
}
exports.getLatestDocumentVersion = getLatestDocumentVersion;
var DocumentListModal = exports.DocumentListModal = /** @class */ (function (_super) {
    __extends(DocumentListModal, _super);
    function DocumentListModal(props) {
        var _this = _super.call(this, props) || this;
        _this.DOC_BASE_PATH = "/resources/documents/";
        _this.documents = [];
        _this.getDocumentPath = function (docType, version) {
            var omegaBreakdownRebranding = process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED ? JSON.parse(process.env.REACT_APP_OMEGA_BREAKDOWN_REBRANDING_ENABLED) : false;
            if (omegaBreakdownRebranding && DocTypeEnum.BDI == docType && getDocumentVersionNumberOnly(version) >= exports.omegaBreakDownIntroducedVersion) {
                return "".concat(_this.DOC_BASE_PATH, "LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "/").concat(version, "/Allianz_Annual_Car_Britannia_Rescue_BDI_").concat(version, ".pdf");
            }
            return "".concat(_this.DOC_BASE_PATH, "LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "/").concat(version, "/LV_").concat(_this.documentBrand, "_").concat(_this.documentProduct, "_").concat(docType, "_").concat(version, ".pdf");
        };
        _this.setDocumentProduct();
        _this.setAvailableDocTypesAndVersion();
        _this.setDocumentBrand();
        return _this;
    }
    DocumentListModal.prototype.componentDidMount = function () {
        this.prepareDocuments();
        this.setDocumentSize();
    };
    DocumentListModal.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.coverTier !== prevProps.coverTier
            || this.props.isMLEVisible !== prevProps.isMLEVisible
            || this.props.isBDIVisible !== prevProps.isBDIVisible) {
            this.setAvailableDocTypesAndVersion();
            this.documents = [];
            this.setState({ documents: this.documents });
            this.prepareDocuments();
            this.setDocumentSize();
        }
    };
    DocumentListModal.prototype.prepareDocuments = function () {
        switch (this.documentProduct) {
            case DocProductEnum.ANNUAL_CAR:
                this.handleAnnualCar();
                break;
            case DocProductEnum.CAR:
                this.handleFlowCar();
                break;
            case DocProductEnum.RENTERS:
                this.handleRenters();
                break;
        }
    };
    DocumentListModal.prototype.setDocumentProduct = function () {
        switch (this.props.productName) {
            case services_1.ProductsEnum.WOLF_MOTOR:
                this.documentProduct = DocProductEnum.ANNUAL_CAR;
                break;
            case services_1.ProductsEnum.MOTOR:
            case services_1.ProductsEnum.SUBSCRIPTION:
                this.documentProduct = DocProductEnum.CAR;
                break;
            case services_1.ProductsEnum.RENTERS:
                this.documentProduct = DocProductEnum.RENTERS;
                break;
            default:
                break;
        }
    };
    DocumentListModal.prototype.setAvailableDocTypesAndVersion = function () {
        var coverTier = this.props.coverTier;
        switch (this.documentProduct) {
            case DocProductEnum.ANNUAL_CAR:
                if (coverTier === services_1.ALLIANZ_ESSENTIALS) {
                    this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID_ALLIANZ_ESSENTIALS];
                    if (this.props.isMLEVisible) {
                        this.availableDocTypes.push(DocTypeEnum.MLE);
                    }
                }
                else if (coverTier === services_1.ALLIANZ_SILVER) {
                    this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID_ALLIANZ_SILVER];
                    if (this.props.isMLEVisible) {
                        this.availableDocTypes.push(DocTypeEnum.MLE);
                    }
                }
                else {
                    this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID, DocTypeEnum.MLE];
                }
                if (this.props.isBDIVisible) {
                    this.availableDocTypes.push(DocTypeEnum.BDI);
                }
                this.setVersionByDate(AnnualCarVersionDate);
                break;
            case DocProductEnum.CAR:
                this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID, DocTypeEnum.MLE];
                this.setVersionByDate(CarVersionDate);
                break;
            case DocProductEnum.RENTERS:
                this.availableDocTypes = [DocTypeEnum.DOI, DocTypeEnum.IPID];
                this.setVersionByDate(RentersVersionDate);
                break;
        }
    };
    DocumentListModal.prototype.setVersionByDate = function (docVersions) {
        this.documentVersion = getDocumentVersionByDate(this.props.policyDate);
    };
    DocumentListModal.prototype.setDocumentBrand = function () {
        this.documentBrand = getDocumentBrand(this.documentVersion);
    };
    DocumentListModal.prototype.handleAnnualCar = function () {
        var _this = this;
        switch (this.documentBrand) {
            case BrandEnum.Allianz:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case BrandEnum.Flow:
                switch (this.documentVersion) {
                    case DocVersionEnum.V1:
                        this.availableDocTypes.forEach(function (docType) {
                            _this.createDocument(docType);
                        });
                        break;
                    case DocVersionEnum.V2:
                    case DocVersionEnum.V3:
                        if (this.props.isBDIVisible) {
                            this.createDocument(DocTypeEnum.BDI, DocVersionEnum.V1);
                        }
                        this.createDocument(DocTypeEnum.DOI);
                        this.createDocument(DocTypeEnum.IPID);
                        this.createDocument(DocTypeEnum.MLE, DocVersionEnum.V1);
                        break;
                }
                break;
        }
        this.getPIUDocument();
    };
    DocumentListModal.prototype.handleFlowCar = function () {
        var _this = this;
        switch (this.documentVersion) {
            case DocVersionEnum.V1:
            case DocVersionEnum.V3:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case DocVersionEnum.V2:
                this.createDocument(DocTypeEnum.DOI);
                this.createDocument(DocTypeEnum.IPID, DocVersionEnum.V1);
                this.createDocument(DocTypeEnum.MLE, DocVersionEnum.V1);
        }
    };
    DocumentListModal.prototype.handleRenters = function () {
        var _this = this;
        switch (this.documentVersion) {
            case DocVersionEnum.V1:
                this.availableDocTypes.forEach(function (docType) {
                    _this.createDocument(docType);
                });
                break;
            case DocVersionEnum.V2:
                this.createDocument(DocTypeEnum.DOI, DocVersionEnum.V2);
                this.createDocument(DocTypeEnum.IPID, DocVersionEnum.V1);
                break;
        }
    };
    DocumentListModal.prototype.createDocument = function (docType, version) {
        var _this = this;
        if (version === void 0) { version = this.documentVersion; }
        this.getDocumentSize(this.getDocumentPath(docType, version)).subscribe(function (size) {
            if (size) {
                var document_1 = {
                    key: (0, uuid_1.v4)(),
                    href: _this.getDocumentPath(docType, version),
                    documentId: "".concat(docType, "_DOC"),
                    documentName: _this.getDocumentFullName(docType),
                    documentFileSize: size,
                };
                _this.setState({ documents: __spreadArray(__spreadArray([], _this.state.documents, true), [document_1], false) });
            }
        });
    };
    DocumentListModal.prototype.getDocumentFullName = function (docType) {
        return "".concat(DocNameMap.find(function (d) { return d.docType === docType; }).docFullName);
    };
    DocumentListModal.prototype.getPIUDocument = function () {
        var _this = this;
        var privacyPath = "".concat(this.DOC_BASE_PATH, "LV_Allianz_how_we_use_personal_information.pdf");
        this.getDocumentSize(privacyPath).subscribe(function (size) {
            if (size) {
                var document_2 = {
                    key: (0, uuid_1.v4)(),
                    href: privacyPath,
                    documentId: services_1.CAR_PIU_PDF_ID,
                    documentName: services_1.CAR_PIU_PDF_NAME,
                    documentFileSize: size
                };
                _this.setState({ documents: __spreadArray(__spreadArray([], _this.state.documents, true), [document_2], false) });
            }
        });
    };
    DocumentListModal.prototype.getDocumentSize = function (path) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.baseRequestService.getDocumentSize(path).subscribe(function (response) {
                var size = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
                observer.next(size);
                observer.complete();
            });
        });
    };
    DocumentListModal.prototype.setDocumentSize = function () {
        var _this = this;
        this.documents.forEach(function (doc) {
            _this.baseRequestService.getDocumentSize(doc.href).subscribe(function (response) {
                doc.documentFileSize = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
            });
        });
        this.setState({
            documents: this.documents
        });
    };
    DocumentListModal.prototype.render = function () {
        if (this.state) {
            var documentRender = this.state.documents.map(function (document) { return (React.createElement("li", { key: document.documentId, className: "media" },
                React.createElement("a", { className: "document-download-link no-underline", href: document.href, download: document.documentName.toLowerCase().endsWith('.pdf') ? document.documentName : "".concat(document.documentName, ".pdf"), id: document.documentId },
                    React.createElement("img", { className: "pdf-icon active-icon", alt: "pdf document icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/pdf-icon.png") }),
                    React.createElement("h5", { className: "document-name d-flex document-link-text" },
                        document.documentName,
                        ", PDF, ",
                        document.documentFileSize)))); });
            if (this.props.isAccordion) {
                return documentRender;
            }
            else {
                return React.createElement("ul", { className: "list-unstyled" }, documentRender);
            }
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], DocumentListModal.prototype, "baseRequestService", void 0);
    return DocumentListModal;
}(React.Component));
//# sourceMappingURL=DocumentListModal.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/DocumentListModal.js
// module id = 191
// module chunks = 0